import { render, staticRenderFns } from "./TS08.vue?vue&type=template&id=7a39fc1a&scoped=true&"
import script from "./TS08.vue?vue&type=script&lang=js&"
export * from "./TS08.vue?vue&type=script&lang=js&"
import style0 from "./TS08.vue?vue&type=style&index=0&id=7a39fc1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39fc1a",
  null
  
)

export default component.exports